const images = require.context('../public/img', true);
const DEFAULT_CELLS_WIDE = 25;
const DEFAULT_CELLS_HIGH = 15;
const DEFAULT_CELL_WIDTH = 32;
const DEFAULT_CELL_HEIGHT = 32;

let emptyRules = [];
let disabledRules = [];
for (let i = 0; i < 200; i++) {
    emptyRules.push([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    disabledRules[i] = false;
}
let cells = new Array(DEFAULT_CELLS_WIDE * DEFAULT_CELLS_HIGH).fill(1);

let audio1 = '/sounds/bump.wav';
let audio2 = '/sounds/collide1.wav';
let audio3 = '/sounds/pickup.wav';
let audio4 = '/sounds/destroy2.wav';
let audio5 = '/sounds/explode.wav';
let audio6 = '/sounds/hit.wav';
let audio7 = '/sounds/sand.wav';
let audio8 = '/sounds/teleport.wav';
let audio9 = '/sounds/completelevel.wav';      

export const appConfig = {
        rules: emptyRules,  
        disabledRules: disabledRules,  
        modalShow: false,
        settingsModalShow: false,
        spriteModalShow: false,
        mapModalShow: false,

        rerender: 0,         
        // Sprites   
        spriteSheet: "chicken.png",
        imgsrc: images(`./chicken.png`),
        rulesImgSrc: images(`./chicken.png`),
        spriteWidth: 32,
        spriteHeight: 32,
        totalSprites: 16,
        spriteSheetWidth: 256,
        spriteSheetHeight: 64,
        spritesPerRow: 8, // was 8 make custom and default to 8 again
        spriteIndex: 1,  
        programState:"playing",
        
        // Maps
        mapCells: [cells.slice(), cells.slice(), cells.slice(), cells.slice(), cells.slice(), cells.slice(), cells.slice(), cells.slice(), cells.slice()],
        mapNames: ["Map 1", "Map 2", "Map 3", "Map 4", "Map 5", "Map 6"],
        activeMap: 0,        
        cellswide: DEFAULT_CELLS_WIDE,
        cellshigh: DEFAULT_CELLS_HIGH,
        cellwidth: DEFAULT_CELL_WIDTH,
        cellheight: DEFAULT_CELL_HEIGHT,
        stageWide: DEFAULT_CELLS_WIDE,
        stageHigh: DEFAULT_CELLS_HIGH,
        persistent: false,
        worldWrap: false,
        timer1: 400,
        timer2: 800,
        bordercell: 1, // Sprite index for border cells starting from 1
        audio: [audio1, audio2, audio3, audio4, audio5, audio6, audio7, audio8, audio9],
        audiolabels: ["Sound 1", "Sound 2", "Sound 3", "Sound 4", "Sound 5", "Sound 6", "Sound 7", "Sound 8", "Sound 9"]
}

export default appConfig